import { useEffect, useState } from "react";
import { message } from "antd";
import { useEgresadoContext } from "../context/EgresadoProvident";
import egresadosServices from "../services/alumnos/egresadosServices"; 
import IMG_PERFIL_GENERICO from './../../../assets/images/egresados/perfil_generico.png';
import IMG_PORTADA_GENERICA from './../../../assets/images/egresados/portada_generica.png'; 


const useEgresado = () => {
  const { alumno, getProfile } = useEgresadoContext();
  const [imageProfile, setImageProfile] = useState(null);
  const [imagePortada, setImagePortada] = useState(null);
  const [loading, setLoading] = useState(true);

  const getProfileEgresado = async () => {
    setLoading(true);
    const response = await egresadosServices.getProfileEgresados();
    setLoading(false);
    return response;
  }

  const getImage = async (type, path, setImage) => {
    const image = path ? await egresadosServices.getImagen(path) : null;
    setImage(image?.success ? image.image : type === "PERFIL" ? IMG_PERFIL_GENERICO : IMG_PORTADA_GENERICA);
  };

  const handleDelete = async (type) => {
    const response = await egresadosServices.deleteImage(type);
    if (response?.success) {
      message.success(`Imagen de ${type} eliminada exitosamente`);
      getImage(type, null, type === "PERFIL" ? setImageProfile : setImagePortada);
    } else {
      message.error(response?.message || 'Error al eliminar la imagen');
    }

  }
  // Manejo de la carga de imágenes de perfil o portada
  const handleUpload = async (file, type) => {
    const formData = new FormData();
    formData.append('file', file);

    let uploadResponse = null;

    if (type === "PERFIL") {
      uploadResponse = await egresadosServices.uploadImageProfile(formData);
    } else if (type === "PORTADA") {
      uploadResponse = await egresadosServices.uploadImageCover(formData);
    }

    if (uploadResponse?.success) {
      message.success(`Imagen de ${type} cargada exitosamente`);
      getImage(type, uploadResponse?.data?.filename, type === "PERFIL" ? setImageProfile : setImagePortada);
    } else {
      getImage(type, null, type === "PERFIL" ? setImageProfile : setImagePortada);
      message.error(uploadResponse?.message || 'Error al cargar la imagen');
    }
  };

  const updateInformacion = async (data) => {
    const response = await egresadosServices.updateInformacion(data);
    if (!response.success) {
      message.error(response.message);
    } else {
      getProfile();
      message.success("Información actualizada exitosamente");
    }
    return response;
  };

  const getCvPdf = async (values) => {
    setLoading(true);
    const response = await egresadosServices.getCvPdf(values);
    setLoading(false);
    return response;
  }

  const validarDatosEgresado = async () => {
    const response = await getProfileEgresado();
    const alumno = response?.data;

    const validaciones = [ 
      { condition: !alumno?.objetivo_profesional, message: "Añade un objetivo profesional" },
      { condition: !(alumno?.exp_laboral?.length > 0), message: "Añade al menos una experiencia laboral" },
      { condition: !(alumno?.exp_academica?.length > 0), message: "Añade al menos una experiencia académica" },
      { condition: !alumno?.habilidades.some(h => h.tipo_habilidad === "TECNICAS"), message: "Añade al menos una habilidad técnica" },
      { condition: !alumno?.habilidades.some(h => h.tipo_habilidad === "BLANDAS"), message: "Añade al menos una habilidad blanda" },
      { condition: !(alumno?.idiomas?.length > 0), message: "Añade al menos un idioma" },
      { condition: !(alumno?.software?.length > 0), message: "Añade al menos un software" }
    ];

    for (const { condition, message: errorMessage } of validaciones) {
      if (condition) {
        message.error("Para generar tu CV: " + errorMessage);
        return false;
      }
    }

    return true;
  };

  useEffect(() => {
    // Solo ejecutamos este efecto si alumno tiene datos
    if (alumno) {
      Promise.all([
        getImage("PERFIL", alumno?.path_photo, setImageProfile),
        getImage("PORTADA", alumno?.path_cover, setImagePortada),
      ]);
    }

    setLoading(false);

  }, [alumno]);

  return { loading, alumno, handleUpload, handleDelete, imageProfile, imagePortada, updateInformacion, getProfile, getCvPdf, validarDatosEgresado, getProfileEgresado };
};

export default useEgresado;
